import Vue from 'vue'

import NavList from '@/components/layout/navigation/NavList'
import NavItem from '@/components/layout/navigation/NavItem'
import NavTitle from '@/components/layout/navigation/NavTitle'
import SubNav from '@/components/layout/navigation/SubNav'
import SubNavItem from '@/components/layout/navigation/SubNavItem'

Vue.component(NavList.name, NavList)
Vue.component(NavItem.name, NavItem)
Vue.component(NavTitle.name, NavTitle)
Vue.component(SubNav.name, SubNav)
Vue.component(SubNavItem.name, SubNavItem)
